export class StrokeRecognitionSwitcher {
  private static _instance: StrokeRecognitionSwitcher | null = null;

  private _isUsingOpenAI: boolean = true;

  // Private constructor to prevent direct instantiation
  private constructor() {}

  // Singleton accessor
  public static get instance(): StrokeRecognitionSwitcher {
    if (!this._instance) {
      this._instance = new StrokeRecognitionSwitcher();
    }
    return this._instance;
  }

  // isUsingOpenAI getter/setter
  get isUsingOpenAI(): boolean {
    return this._isUsingOpenAI;
  }

  set isUsingOpenAI(value: boolean) {
    this._isUsingOpenAI = value;
  }

  // Example utility function to switch recognition engine
  public toggleEngine(): void {
    this._isUsingOpenAI = !this._isUsingOpenAI;
  }

  // Example function to describe current state
  public describe(): string {
    return `StrokeRecognitionSwitcher using ${this._isUsingOpenAI ? "OpenAI" : "Default"} engine`;
  }
}
